const SvgCloseRound = ({
  fill = "#fff",
  fillround = "none",
  opacity = 0.5,
}) => {
  return (
    <svg
      className="svgcloseround"
      width="41"
      height="41"
      viewBox="0 0 41 41"
      fill={fillround}
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        opacity={opacity}
        d="M20.75 37.125C30.0698 37.125 37.625 29.5698 37.625 20.25C37.625 10.9302 30.0698 3.375 20.75 3.375C11.4302 3.375 3.875 10.9302 3.875 20.25C3.875 29.5698 11.4302 37.125 20.75 37.125Z"
        stroke={fill}
        strokeWidth="1.75"
      />
      <path
        d="M24.9688 16.0313L16.5313 24.4688M16.5312 16.0312L24.9688 24.4688"
        stroke={fill}
        strokeWidth="1.75"
        strokeLinecap="round"
      />
    </svg>
  );
};

export default SvgCloseRound;
